<template>
  <div class="result-check">
      <a-descriptions bordered v-if="crcResponse" size="small" column= "1">
        <a-descriptions-item label="打印时间">{{
          crcResponse.printTime
        }}</a-descriptions-item>
      </a-descriptions>
      <a-descriptions class="mt10" bordered v-if="measureDataResponse" size="small" :column= "2">
        <a-descriptions-item label="测量时间">{{
          measureTime
        }}</a-descriptions-item>
        <a-descriptions-item label="积分时间(s)">{{ tm }}</a-descriptions-item>
        <a-descriptions-item label="分析仪">{{ analyzer }}</a-descriptions-item>
        <a-descriptions-item label="频率计权" v-if="analyzer != 'ALL'">{{
          frequencyWeight
        }}</a-descriptions-item>
        <a-descriptions-item label="时间计权">{{
          timeWeight
        }}</a-descriptions-item>
        <a-descriptions-item label="统计" v-if="analyzer == 'STA'">{{
          sta
        }}</a-descriptions-item>
        <a-descriptions-item label="灵敏度级(dB)">{{
          lxdb
        }}</a-descriptions-item>
      </a-descriptions>
      <a-descriptions class="mt10" bordered v-if="measureDataResponse" size="small" :column= "2">
        <a-descriptions-item v-for="item in list" :key="item.unit" :label="item.label">{{ item.value }}</a-descriptions-item>
      </a-descriptions>
    <!-- <div class="check-box mt10" v-if="measureDataResponse">
      <div class="data-item" v-for="item in list" :key="item.unit">
        <div class="same no-bottom-b">{{ item.label }}</div>
        <div class="same no-bottom-b1">{{ item.value }}</div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { parseData } from '../api/api';
const dataList = [
  { label: 'Leq,T(dB)', codeKey: 'leq', value: '' },
  { label: 'L10(dB)', codeKey: 'l10', value: '' },
  { label: 'L50(dB)', codeKey: 'l50', value: '' },
  { label: 'L90(dB)', codeKey: 'l90', value: '' },
  { label: 'LAE(dB)', codeKey: 'lae', value: '' },
  { label: 'Lmax(dB)', codeKey: 'lmax', value: '' },
  { label: 'Lmin(dB)', codeKey: 'lmin', value: '' },
  { label: 'SD(dB)', codeKey: 'sd', value: '' },

  { label: 'LAeq,T(dB)', codeKey: 'laeq', value: '' },
  { label: 'LAmax(dB)', codeKey: 'lamax', value: '' },
  { label: 'LAmin(dB)', codeKey: 'lamin', value: '' },
  { label: 'LCeq,T(dB)', codeKey: 'lceq', value: '' },
  { label: 'LCmax(dB)', codeKey: 'lcmax', value: '' },
  { label: 'LCmin(dB)', codeKey: 'lcmin', value: '' },
  { label: 'LZeq,T(dB)', codeKey: 'lzeq', value: '' },
  { label: 'LZmax(dB)', codeKey: 'lzmax', value: '' },
  { label: 'LZmin(dB)', codeKey: 'lzmin', value: '' },

  { label: '31.5Hz(dB)', codeKey: 'oct31_5', value: '' },
  { label: '63Hz(dB)', codeKey: 'oct63', value: '' },
  { label: '125Hz(dB)', codeKey: 'oct125', value: '' },
  { label: '250Hz(dB)', codeKey: 'oct250', value: '' },
  { label: '500Hz(dB)', codeKey: 'oct500', value: '' },
  { label: '1KHz(dB)', codeKey: 'oct1000', value: '' },
  { label: '2KHz(dB)', codeKey: 'oct2000', value: '' },
  { label: '4KHz(dB)', codeKey: 'oct4000', value: '' },
  { label: '8KHz(dB)', codeKey: 'oct8000', value: '' },
];
export default {
  name: 'result-checking-mobile',

  data() {
    return {
      crcResponse: null,
      measureDataResponse: null,
      list: [],
      measureTime: '',
      tm: '',
      analyzer: '',
      timeWeight: '',
      sta: '',
      frequencyWeight: '',
      lxdb: '',
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const urlParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlParams.entries());
      parseData(params).then(({ response }) => {
        const { crcResponse, measureDataResponse } = response;

        this.crcResponse = crcResponse;
        this.measureDataResponse = measureDataResponse;

        if (measureDataResponse) {
          const {
            analyzer,
            data,
            frequencyWeight,
            measureTime,
            sta,
            timeWeight,
            tm,
          } = measureDataResponse;
          this.measureTime = measureTime;
          this.tm = tm;
          this.analyzer = analyzer;
          this.timeWeight = timeWeight;
          this.sta = sta;
          this.frequencyWeight = frequencyWeight;

          let arr = [];
          dataList.forEach((item) => {
            for (let key in data) {
              if (key == 'lxdb') {
                this.lxdb = data[key] ? data[key].toFixed(1) : data[key];
              }
              if (item.codeKey == key) {
                if (analyzer == 'STA') {
                  if (item.codeKey == 'leq') {
                    item.label = 'Leq,T(dB)';
                  } else if (item.codeKey == 'lmax') {
                    item.label = 'Lmax(dB)';
                  } else if (item.codeKey == 'lmin') {
                    item.label = 'Lmin(dB)';
                  } else if (item.codeKey == 'lae') {
                    item.label = 'SEL(dB)';
                  }
                }
                if (analyzer == 'OCTL') {
                  if (item.codeKey == 'leq') {
                    item.label = 'LAeq,T(dB)';
                  } else if (item.codeKey == 'lmax') {
                    item.label = 'LAFmax(dB)';
                  } else if (item.codeKey == 'lmin') {
                    item.label = 'LAFmin(dB)';
                  }
                }
                item.value = data[key] ? data[key].toFixed(1) : data[key];
                arr.push(item);
              }
            }
          });
          this.list = arr;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result-check {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  padding: 20px 10px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}
.check-box {
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #e8e8e8;
  .data-item {
    // border-bottom: 1px solid #ddd;
    flex: 1;
  }
  .same {
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #e8e8e8;
    border-left: none;
    color: #111;
    &.no-bottom-b {
      border-bottom: none;
      background: #fafafa;
    }
    &.no-bottom-b1 {
      margin-bottom: -1px;
    }
  }
}
</style>
